import React from 'react';
import { formatDate, formatTime } from '../../../utils/date';
import { GetBudgetQuery } from '../../../graphql/datamodel.gen';
import moment from 'moment';
import StarterKit from '@tiptap/starter-kit';
import Underline from '@tiptap/extension-underline';
import {
  computeItineraryTotalWithoutVAT,
  computeItineraryTotalWithVAT,
  computeItineraryVATSumatory,
} from '../utils';
import { ItineraryCandidate } from '../CreateItinerary/CreateItineraryForm';
import Logo from '../../../assets/logo.jpeg';
import { Space } from 'antd';
import BasicHTMLEditor from '../../BasicHTMLEditor';
import { generateHTML } from '@tiptap/react';

interface IProps {
  budget?: GetBudgetQuery['budget'];
}

class CreateBudgetPDF extends React.Component<IProps, any> {
  render(): React.ReactNode {
    return <CreateBudgetPDFView budget={this.props.budget} />;
  }
}

const formatAmount = (amount: number): string => {
  return amount.toFixed(2);
};

const CreateBudgetPDFView: React.FC<IProps> = (props: IProps) => {
  const budget = props.budget;

  return (
    <html id="budget-pdf" lang="en" style={{ display: 'none' }}>
      <head>
        <meta charSet="utf-8" />

        <title>The HTML5 Herald</title>
        <meta name="description" content="The HTML5 Herald" />
        <meta name="author" content="SitePoint" />

        <link
          rel="stylesheet"
          media="print"
          href="https://stackpath.bootstrapcdn.com/bootstrap/4.5.0/css/bootstrap.min.css"
          integrity="sha384-9aIt2nRpC12Uk9gS9baDl411NQApFmC26EwAOH8WgZl5MYYxFfc+NcPb1dKGj7Sk"
          crossOrigin="anonymous"
        />
        <script
          src="https://stackpath.bootstrapcdn.com/bootstrap/4.5.0/js/bootstrap.min.js"
          integrity="sha384-OgVRvuATP1z7JjHLkuOU7Xw704+h835Lr+6QL9UvYjZE3Ipu6Tp75j7Bh/kR0JKI"
          crossOrigin="anonymous"
        />
      </head>

      <body>
        <div className="container" style={{ marginTop: '30px' }}>
          <div className="row">
            <div className="col">
              <h1 style={{ color: '#836831' }}>Presupuesto</h1>
              <table
                className="table table-sm table-bordered table-striped"
                style={{ marginTop: '50px' }}
              >
                <tbody>
                  <tr>
                    <th>Núm. de presupuesto</th>
                    <td>{budget?.readableId}</td>
                  </tr>
                  <tr>
                    <th>Fecha</th>
                    <td>
                      {budget?.creationDate &&
                        formatDate(moment(budget?.creationDate))}
                    </td>
                  </tr>
                </tbody>
              </table>
              <hr />
              <h5>Información del cliente</h5>
              <table className="table table-sm table-bordered table-striped">
                <tbody>
                  <tr>
                    <th>Código</th>
                    <td>{budget?.client?.volcanoClientId}</td>
                  </tr>
                  <tr>
                    <th>Titular</th>
                    <td>{budget?.client?.name}</td>
                  </tr>
                  <tr>
                    <th>NIF</th>
                    <td>{budget?.client?.nif}</td>
                  </tr>
                  <tr>
                    <th>Teléfono</th>
                    <td>{budget?.client?.phone}</td>
                  </tr>
                  <tr>
                    <th>Email</th>
                    <td>{budget?.client?.volcanoEmail}</td>
                  </tr>
                </tbody>
              </table>
              <hr />
            </div>
            <div className="col">
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-end',
                }}
              >
                <img
                  src={Logo}
                  width={175}
                  height={175 * 0.9045488441}
                  className={'float-right'}
                  alt="Logo"
                />
                <div style={{ marginTop: '50px', textAlign: 'right' }}>
                  {`${budget?.company.data.cif} - ${budget?.company.data.name}`}
                  <br />
                  {`${budget?.company.data.address}`}
                  <br />
                  {`${budget?.company.data.zip} - ${budget?.company.data.location}`}
                  <br />
                  {`Tel. ${budget?.company.data.phone}`}
                  {`Fax. ${budget?.company.data.fax}`}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <h5>Referencia</h5>
              <table className="table table-sm table-bordered table-striped">
                <tbody>
                  <tr>
                    <th>Atendido por</th>
                    <td>{budget?.attendedBy}</td>
                  </tr>
                  <tr>
                    <th>Su referencia</th>
                    <td>{budget?.reference}</td>
                  </tr>
                  <tr>
                    <th>A la atención de</th>
                    <td>{budget?.contact?.name}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <hr />
          {budget?.client?.template?.heading && (
            <div className="row" style={{ marginTop: '50px' }}>
              <div
                className="col"
                style={{ whiteSpace: 'pre-line' }}
                dangerouslySetInnerHTML={{
                  __html: generateHTML(budget?.client?.template?.heading, [
                    StarterKit,
                    Underline,
                  ]),
                }}
              ></div>
            </div>
          )}
          <div className="row" style={{ marginTop: '50px' }}>
            <div className="col">
              <h5>DETALLE DEL PRESUPUESTO</h5>

              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th scope="col">Fecha</th>
                    <th scope="col">Concepto</th>
                    <th scope="col">Importe</th>
                  </tr>
                </thead>

                <tbody>
                  {budget?.itineraries.map((itinerary) => {
                    return (
                      <tr key={itinerary.id}>
                        <td>
                          {formatDate(moment(itinerary.departureTime))}
                          <br />
                          <br />
                          {formatDate(moment(itinerary.arrivalTime))}
                        </td>
                        <td>
                          {itinerary.itineraryDescription}
                          <table
                            className="table table-sm table-borderless table-striped"
                            style={{ marginTop: '20px' }}
                          >
                            <tbody>
                              <tr>
                                <th>Origen</th>
                                <td>{itinerary.departureAddress}</td>
                              </tr>
                              {itinerary.provisionAddress && (
                                <tr>
                                  <th>Disposición</th>
                                  <td>{itinerary.provisionAddress}</td>
                                </tr>
                              )}
                              <tr>
                                <th>Destino</th>
                                <td>{itinerary.arrivalAddress}</td>
                              </tr>
                            </tbody>
                          </table>
                          {itinerary.groupName && (
                            <Space>
                              <strong>{itinerary.groupName}</strong>
                            </Space>
                          )}
                          <table
                            className="table table-sm table-borderless table-striped"
                            style={{ marginTop: '20px' }}
                          >
                            <tbody>
                              <tr>
                                <th>Vehiculos</th>
                                <td>{itinerary.numVehicles}</td>
                              </tr>
                              <tr>
                                <th>Plazas</th>
                                <td>{itinerary.numPassengers}</td>
                              </tr>
                              <tr>
                                <th>Hora de salida</th>
                                <td>
                                  {formatTime(moment(itinerary.departureTime))}
                                </td>
                              </tr>
                              <tr>
                                <th>Hora de llegada</th>
                                <td>
                                  {formatTime(moment(itinerary.arrivalTime))}
                                </td>
                              </tr>
                              <tr>
                                <th>Modelo</th>
                                <td>{itinerary.vehicleCategory?.name}</td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        <td>
                          <table className="table table-sm table-borderless table-striped">
                            <tbody>
                              {itinerary.amounts.map((amount) => {
                                return (
                                  <tr>
                                    <th>{amount.concept}</th>
                                    <td>{formatAmount(amount.amount)} €</td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                          <table className="table table-sm table-borderless table-striped">
                            <tbody>
                              <tr>
                                <th>Suma de importes</th>
                                <td>
                                  {formatAmount(
                                    computeItineraryTotalWithoutVAT(
                                      itinerary as unknown as ItineraryCandidate,
                                    ),
                                  )}{' '}
                                  €
                                </td>
                              </tr>
                              <tr>
                                <th>I.V.A</th>
                                <td>
                                  {formatAmount(
                                    computeItineraryVATSumatory(
                                      itinerary as unknown as ItineraryCandidate,
                                    ),
                                  )}{' '}
                                  €
                                </td>
                              </tr>
                              <tr>
                                <th>Total</th>
                                <td>
                                  {formatAmount(
                                    computeItineraryTotalWithVAT(
                                      itinerary as unknown as ItineraryCandidate,
                                    ),
                                  )}{' '}
                                  €
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
          {budget?.client?.template?.body && (
            <div className="row" style={{ marginTop: '50px' }}>
              <div
                className="col"
                style={{ whiteSpace: 'pre-line' }}
                dangerouslySetInnerHTML={{
                  __html: generateHTML(budget?.client?.template?.body, [
                    StarterKit,
                    Underline,
                  ]),
                }}
              ></div>
            </div>
          )}
        </div>
      </body>
    </html>
  );
};

export default CreateBudgetPDF;
